/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const inlineSuggestCommitId = 'editor.action.inlineSuggest.commit';

export const inlineSuggestCommitAlternativeActionId = 'editor.action.inlineSuggest.commitAlternativeAction';

export const showPreviousInlineSuggestionActionId = 'editor.action.inlineSuggest.showPrevious';

export const showNextInlineSuggestionActionId = 'editor.action.inlineSuggest.showNext';

export const jumpToNextInlineEditId = 'editor.action.inlineSuggest.jump';

export const hideInlineCompletionId = 'editor.action.inlineSuggest.hide';

export const toggleShowCollapsedId = 'editor.action.inlineSuggest.toggleShowCollapsed';

export const renameSymbolCommandId = 'editor.action.inlineSuggest.renameSymbol';
